import React, { Component } from 'react';
import {
  Nav, NavItem, Tab, Row, Col, Button, Glyphicon,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import FormContainer from './forms/FormContainer.jsx';
import ContactForm from './forms/ContactForm.jsx';
import ExperienceForm from './forms/ExperienceForm.jsx';
import ReferenceForm from './forms/ReferenceForm.jsx';
import PersonalInformationForm from './forms/PersonalInformationForm.jsx';
import DocumentUploaderForm from './forms/DocumentUploaderForm.jsx';
import HistoryForm from './forms/HistoryForm.jsx';
import ConfirmationModal from './ConfirmationModal.jsx';

import { setRatingType } from '../actions/ui';
import { updateField } from '../actions/form';
import { createProfile, fetchProfileOptions } from '../actions/profile';

import styles from '../styles/variables.scss';

export class TabMenu extends Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.state = {
      selectedTab: 'personalInfo',
      nextDisabled: false,
      modal: null,
    };

    this.headerTitle = 'TRD Driver Sign-up';
    this.tabsMap = {
      personalInfo: 'Personal Information',
      contacts: 'Contacts',
      racingExperience: 'Race Experience',
      history: 'Team Experience',
      references: 'References',
      documents: 'Documents',
    };

    this.onBack = this.onBack.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.selectTab = this.selectTab.bind(this);
  }

  componentDidMount() {
    this.props.fetchProfileOptions();
    this.props.updateField('profile', 'profileType', 'driver');
    this.props.setRatingType('profile');
  }

  onBack() {
    // Get index of selected tab
    const eventKeyList = _.keys(this.tabsMap);
    const indexOfSelectedKey = eventKeyList.indexOf(this.state.selectedTab);

    // If previous index is out of range, don't change anything
    if (indexOfSelectedKey !== 0) {
      // Get the name of the next event key and update state
      const prevEventKey = _.keys(this.tabsMap)[indexOfSelectedKey - 1];
      this.setState({ selectedTab: prevEventKey, nextDisabled: false });
    } else {
      this.props.history.push('/');
    }
  }

  onNext() {
    // Get index of selected tab
    const eventKeyList = _.keys(this.tabsMap);
    const indexOfSelectedKey = eventKeyList.indexOf(this.state.selectedTab);

    // If next index is out of range, don't change anything
    if (indexOfSelectedKey < eventKeyList.length - 1) {
      // Get the name of the next event key and update state
      const nextEventKey = _.keys(this.tabsMap)[indexOfSelectedKey + 1];
      this.setState({ selectedTab: nextEventKey });
    }

    if (this.state.selectedTab === 'references') {
      this.setState({ nextDisabled: true });
    } else {
      this.setState({ nextDisabled: false });
    }
  }

  onSubmit() {
    if (
      this.props.profile.fullName
      && this.props.profile.email
      && this.props.profile.birthdate
      && this.props.profile.mobileNumber
    ) {
      this.setState({
        modal: (
          <ConfirmationModal
            showModal
            onConfirm={this.props.createProfile}
            onClose={ () => { this.setState({ modal: null }); } }
            message="Are you sure you want to submit your driver profile? This action cannot be undone."
          />
        ),
      });
    }
  }

  getFormComponent(eventKey) {
    const componentSwitch = {
      personalInfo: () => (
        <FormContainer name={this.tabsMap.personalInfo}>
          <PersonalInformationForm
            name={this.tabsMap.personalInfo}
            currentUserLevel={this.headerTitle}
            rules={this.props.rules}
          />
        </FormContainer>
      ),
      contacts: () => (
        <FormContainer name={this.tabsMap.contacts}>
          <ContactForm
            name={this.tabsMap.contacts}
            currentUserLevel={this.headerTitle}
            rules={_.get(this.props.rules, 'contacts[0]')}
          />
        </FormContainer>
      ),
      history: () => (
        <FormContainer name={this.tabsMap.history}>
          <HistoryForm
            name={this.tabsMap.history}
            currentUserLevel={this.headerTitle}
            rules={_.get(this.props.rules, 'histories[0]')}
          />
        </FormContainer>
      ),
      racingExperience: () => (
        <FormContainer name={this.tabsMap.racingExperience}>
          <ExperienceForm
            name={this.tabsMap.racingExperience}
            currentUserLevel={this.headerTitle}
            rules={_.get(this.props.rules, 'racingExperience[0]')}
          />
        </FormContainer>
      ),
      references: () => (
        <FormContainer name={this.tabsMap.references}>
          <ReferenceForm
            name={this.tabsMap.references}
            currentUserLevel={this.headerTitle}
            rules={_.get(this.props.rules, 'references[0]')}
          />
        </FormContainer>
      ),
      documents: () => (
        <FormContainer name={this.tabsMap.documents}>
          <DocumentUploaderForm
            name={this.tabsMap.documents}
            currentUserLevel={this.headerTitle}
            rules={_.get(this.props.rules, 'documents[0]')}
          />
        </FormContainer>
      ),
    };
    return componentSwitch[eventKey]();
  }

  selectTab(e) {
    const updates = this.state;

    updates.nextDisabled = (e === 'documents');
    updates.selectedTab = e;
    this.setState(updates);
  }

  render() {
    const { selectedTab } = this.state;
    // Compose NavItems for each item in the tabsMap
    const tabNavs = _.map(this.tabsMap, (tab, key) => (
      <NavItem className="nav-item" eventKey={key} key={key}>
        {tab}
      </NavItem>
    ));

    // Compose tab contents for each item in the tabsMap
    const tabPanes = _.map(this.tabsMap, (tab, key) => (
      <Tab.Pane eventKey={key} key={key}>
        {this.getFormComponent(key)}
      </Tab.Pane>
    ));

    return (
      <React.Fragment>
        <Tab.Container id="tabs-container" activeKey={selectedTab} onSelect={this.selectTab}>
          <Row>
            {this.state.modal}
            <Col id="tabs-nav" xs={2}>
              <Nav className="vertial-nav" stacked>
                {tabNavs}
              </Nav>

              <Row id="btn-container">
                <Col xs={6}>
                  <Button onClick={this.onBack} className="back-btn">
                    <Glyphicon glyph="chevron-left" /> Back
                  </Button>
                </Col>
                <Col xs={6}>
                  <Button
                    onClick={this.onNext}
                    className="next-btn"
                    disabled={this.state.nextDisabled}
                  >
                  Next <Glyphicon glyph="chevron-right" />
                  </Button>
                </Col>

                <Col xs={12}>
                  <Button
                    className="submit-btn"
                    onClick={this.onSubmit}
                    disabled={this.props.submitDisabled}
                  >
                  Submit
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col id="tabs-pane" xs={10}>
              <Tab.Content animation>
                {tabPanes}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>

        <style jsx global>{`
          .nav-item {
            &.active {
              background-color: ${styles.grey};
            }

            a {
              color: ${styles.offwhite};
              border-bottom: 1px solid ${styles.lighterGrey};
              font-size: 14px;

              &:focus,
              &:hover {
                outline: none;
                background-color: ${styles.grey} !important;
              }
            }
          }

          #btn-container {
            margin-top: 5px;

            .back-btn,
            .next-btn {
            }

            .submit-btn {
              width: 100%;
            }
          }
        `}</style>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = state => ({
  rules: _.get(state, 'validation.profile.fields'),
  submitDisabled: state.ui.submitDisabled,
  profile: state.form.profile.fields,
});

export default connect(
  mapStateToProps,
  {
    updateField,
    createProfile,
    fetchProfileOptions,
    setRatingType,
  },
)(withRouter(TabMenu));
